import React, { useState, useEffect } from "react";
import api, { getAssetUrl } from "../utils/api";
import { toast } from "react-toastify";

const ReceiptsPage = () => {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    date: "",
    amount: "",
    image: null,
  });
  const [editingId, setEditingId] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchReceipts();
  }, []);

  const fetchReceipts = async () => {
    try {
      const res = await api.get(`/receipts`);
      setReceipts(res.data);
    } catch (err) {
      console.error("Failed to fetch receipts", err);
      toast.error("Failed to fetch receipts");
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ ADD THIS BLOCK
    if (!formData.name || !formData.amount || !formData.date) {
      toast.error("All fields are required");
      return;
    }

    if (Number(formData.amount) <= 0) {
      toast.error("Amount must be greater than 0");
      return;
    }

    const data = new FormData();
    data.append("name", formData.name);
    data.append("date", formData.date);
    data.append("amount", formData.amount);
    if (formData.image) data.append("image", formData.image);

    setLoading(true);

    try {
      if (editingId) {
        await api.put(`/receipts/${editingId}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Receipt updated");
        setEditingId(null);
      } else {
        await api.post(`/receipts`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Receipt added");
      }

      setFormData({ name: "", date: "", amount: "", image: null });
      fetchReceipts();
    } catch (err) {
      console.error("Failed to save receipt", err);
      toast.error("Failed to save receipt");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this receipt?",
    );
    if (!confirmDelete) return;

    try {
      await api.delete(`/receipts/${id}`);
      toast.success("Receipt deleted");
      fetchReceipts();
    } catch (err) {
      console.error("Failed to delete receipt", err);
      toast.error("Failed to delete receipt");
    }
  };

  const handleEdit = (receipt) => {
    setEditingId(receipt._id);

    let dateVal = "";
    try {
      if (!receipt.date) dateVal = "";
      else if (typeof receipt.date === "string")
        dateVal = receipt.date.split("T")[0];
      else dateVal = new Date(receipt.date).toISOString().slice(0, 10);
    } catch (e) {
      dateVal = "";
    }

    setFormData({
      name: receipt.name || "",
      date: dateVal,
      amount: receipt.amount || "",
      image: null,
    });
  };

  return (
    <div className="content receipts-page">
      <h2>Receipts / Bill Summary</h2>

      <form className="simple-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Receipt Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <input
          type="number"
          name="amount"
          placeholder="Amount"
          value={formData.amount}
          onChange={handleChange}
          required
        />
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={handleChange}
        />

        <button
          className="btn primary small-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? "Saving..." : editingId ? "Update Receipt" : "Add Receipt"}
        </button>
      </form>

      <div className="receipts-list">
        {receipts.length === 0 && <p>No receipts found.</p>}

        {receipts.map((r) => (
          <div key={r._id} className="receipt-card">
            {r.image && (
              <img
                src={getAssetUrl(`/uploads/${r.image}`)}
                alt={r.name}
                className="receipt-image"
                onClick={() =>
                  setPreviewImage(getAssetUrl(`/uploads/${r.image}`))
                }
              />
            )}

            <div className="receipt-info">
              <h4>{r.name}</h4>
              <p>Date: {new Date(r.date).toLocaleDateString()}</p>
              <p>Amount: ₹{r.amount}</p>

              <div className="receipt-actions">
                <button
                  className="btn small edit"
                  type="button"
                  onClick={() => handleEdit(r)}
                >
                  ✏️ Edit
                </button>

                <button
                  className="btn small danger"
                  type="button"
                  onClick={() => handleDelete(r._id)}
                >
                  🗑️ Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {previewImage && (
        <div className="image-modal" onClick={() => setPreviewImage(null)}>
          <span className="close-btn">✖</span>
          <img src={previewImage} alt="Preview" className="modal-content" />
        </div>
      )}
    </div>
  );
};

export default ReceiptsPage;
